import { createSlice } from '@reduxjs/toolkit'

export const plantsWithSiteReducer = createSlice({
    name: "allPlantSiteReducer",
    initialState: {
       plantsWithSite: [],
    },
    reducers: {
        setPlantWithSite: (state, action) => {
            state.plantsWithSite = action.payload;
        },
    }
});

// Action creators are generated for each case reducer function
export const { setPlantWithSite } = plantsWithSiteReducer.actions;

export default plantsWithSiteReducer.reducer; 